// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"f600e3e5","422":"535d431c","455":"820a4c3f","645":"fa139dd1","977":"888769d1"}[chunkId] + ".chunk.js";
};